import { hmsAPI } from '@/api'

export const getRaceStatistics = raceId => hmsAPI.get(`/statistics/${raceId}`)
